import {
  DefaultButton,
  IContextualMenuProps,
  PrimaryButton,
  ProgressIndicator,
  Stack,
} from '@fluentui/react';
import clsx from 'clsx';
import React, { ReactNode, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { PurchaseOrderValues } from 'purchaseOrder/view/types';
import { customStyles } from 'common/components/FooterActionBar/index.styles'; // Adjust path if necessary
import { TestGroupsModal } from '../../TestGroupsModal';
import { TestCaseValues } from '../../types';

interface FooterProps {
  isNew: boolean;
  isLoading: boolean;
  children?: ReactNode;
  onSave: (saveAnother: boolean) => void;
  onCancel: () => void;
  onGroupSelect: (selectedGroupId: string | undefined) => void;
  isCustomTest: boolean;
  onCustomTestSelect: () => void;
  onCreate: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  isNew,
  onSave,
  isLoading,
  children,
  onCancel,
  onGroupSelect,
  isCustomTest,
  onCustomTestSelect,
  onCreate,
}) => {
  const {
    formState: { isDirty, isSubmitting, isValid },
  } = useFormContext<TestCaseValues>();
  const styles = customStyles();
  const [visible, setVisible] = useState<Boolean>(false);

  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: 'saveTestGroup',
        text: 'Save Test Group',
        disabled: !isDirty || !isValid || isSubmitting,
        onClick: (event) => {
          if (event) event.stopPropagation();
          setVisible(true);
          //onSave(true);
        },
      },
    ],
  };
  const menuEditProps: IContextualMenuProps = {
    items: [
      {
        key: 'makeCustomTest',
        text: 'Make Custom Test ',
        disabled: !isDirty || !isValid || isSubmitting,
        onClick: (event) => {
          if (event) event.stopPropagation();
          onCustomTestSelect();
          //onSave(true);
        },
      },
    ],
  };

  const disable = !isDirty || !isValid || isSubmitting;

  return (
    <Stack className={styles.footerStyle}>
      {isLoading && <ProgressIndicator />}
      <Stack
        horizontal
        tokens={{ childrenGap: 10, padding: '25px 25px 25px 25px' }}
      >
        <Stack horizontal grow={4}>
          <Stack.Item grow={2}>
            {isNew ? (
              <DefaultButton
                text="Save"
                primary
                split
                menuProps={menuProps}
                onClick={() => onSave(false)}
                disabled={disable}
              />
            ) : (
              <PrimaryButton
                text="Save"
                disabled={disable}
                split
                menuProps={isCustomTest ? menuProps : menuEditProps}
                onClick={() => onSave(false)}
              />
            )}
            <DefaultButton
              className={clsx(styles.marginLeft15, styles.diabledButton)}
              text="Cancel"
              onClick={() => {
                if (isDirty && !isSubmitting) {
                  const confirm = window.confirm(
                    'Are you sure you want to leave your changes unsaved?'
                  );
                  if (!confirm) return;
                }
                onCancel();
              }}
            />
          </Stack.Item>
          <Stack.Item grow={2}>
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            >
              {children}
              {!isNew && (
                <PrimaryButton
                  onClick={onCreate}
                  iconProps={{
                    iconName: 'Add',
                  }}
                  text="New Test Case"
                />
              )}
            </Stack>
          </Stack.Item>
        </Stack>
      </Stack>
      {visible && (
        <TestGroupsModal
          onClose={() => {
            setVisible(false);
          }}
          onGroupSelect={onGroupSelect}
        />
      )}
    </Stack>
  );
};
